import { CustomizedButton, CustomizedTypography } from '@components/Customized';
import Img from '@components/Image/Image';
import { colorSet } from '@components/Provider';
import { Box, Dialog, makeStyles } from '@material-ui/core';
import { formatDate } from '@utils/formatter';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import Icon from './Icon.svg';

const CAPA_POLICY_UPDATE = 'CAPA_POLICY_UPDATE';

const ServicePolicyDialog = () => {
  const history = useHistory();
  const { modalContainer } = useStyle();
  const modalExpireDate = localStorage.getItem(CAPA_POLICY_UPDATE);
  const currentDate = formatDate(new Date().toISOString(), 'YYYY/MM/DD');
  const isClose = new Date().getTime() >= new Date('2023-04-14').getTime();
  const noShow = modalExpireDate === 'never';
  const isShowInitState = modalExpireDate !== currentDate;
  const [isShow, setIsShow] = useState(noShow ? false : isShowInitState);

  const handleCloseNever = () => {
    setIsShow(false);
    localStorage.setItem(CAPA_POLICY_UPDATE, 'never');
  };

  if (!isShow || isClose || history.location.pathname.includes('terms'))
    return null;

  return (
    <Dialog className={modalContainer} open={isShow}>
      <Box>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          flexDirection="column"
          padding="24px"
          gridGap={12}
        >
          <Img width={63} height={72} src={Icon} />

          <Box
            display="flex"
            justifyContent={'center'}
            alignItems="center"
            gridGap={11}
          >
            <CustomizedTypography variant="h3" fontWeight="700">
              CAPA 이용 약관 변경 안내
            </CustomizedTypography>
          </Box>
        </Box>
        <Box padding="0px 24px 24px 24px">
          <CustomizedTypography gutterBottoms={16} variant="subtitle1">
            제 13 조 (회사의 서비스 이용 계약해제, 해지 및 이용제한)
          </CustomizedTypography>

          <Box bgcolor={colorSet.gray100} padding={2}>
            <CustomizedTypography variant="body1" color="textSecondary">
              1. 회사는 거래의 안정성을 위해 해당 약관과 서비스 운영정책에서
              정한 바에 따라 회원 자격을 정지하거나, 서비스 이용 제한 등의
              조치를 취할 수 있습니다.
            </CustomizedTypography>

            <Box
              width="100%"
              height="1px"
              margin="10px 0"
              bgcolor={colorSet.gray300}
            />

            <CustomizedTypography variant="body1" color="textSecondary">
              2. 회사는 다른 이용자의 약관 위반 행위에 가공하거나 공모한 이용자
              또는 약관 위반 행위를 돕거나 그로 인해 부당한 이득을 취한 이용자에
              대해서도 해당 약관 위반 행위에 대한 제재를 적용할 수 있습니다.
            </CustomizedTypography>

            <Box
              width="100%"
              height="1px"
              margin="10px 0"
              bgcolor={colorSet.gray300}
            />

            <CustomizedTypography variant="body1" color="textSecondary">
              3. 회사가 회원자격을 정지하거나 이용제한 등 기타 필요한 조치를
              취할 경우 이 약관에 특별한 규정이 없는 한 사전에 회원에게 유선
              또는 메일 등 알림을 통해 통보하며 회원이 연락 두절되거나 긴급을
              요하는 부득이한 경우 선조치 후통보 할 수 있습니다.
            </CustomizedTypography>

            <Box
              width="100%"
              height="1px"
              margin="10px 0"
              bgcolor={colorSet.gray300}
            />

            <CustomizedTypography variant="body1" color="textSecondary">
              4. 계정 공유 중 제 3 자가 이용자 본인의 계정을 이용하여 약관 위반
              행위가 발생한다고 하더라도 이용자 본인 및 해당 계정에 제재가
              적용될 수 있습니다.
            </CustomizedTypography>
          </Box>
        </Box>
        <Box
          display="flex"
          justifyContent="center"
          gridGap={12}
          padding="6px 24px 24px 24px"
        >
          <CustomizedButton
            variant="text"
            fullWidth
            onClick={() => {
              window.open('https://capa.ai/terms/service', '_blank');
            }}
          >
            CAPA 이용 약관
          </CustomizedButton>
          <CustomizedButton
            variant="text"
            fullWidth
            onClick={() => {
              window.open('https://capa.ai/terms/policy', '_blank');
            }}
          >
            서비스 운영 정책
          </CustomizedButton>
        </Box>

        <Box
          display="flex"
          justifyContent="center"
          gridGap={12}
          padding="16px 24px 24px 24px"
          position="sticky"
          bottom={0}
          borderTop={`1px solid ${colorSet.gray300}`}
          bgcolor={colorSet.gray000}
        >
          <CustomizedButton fullWidth onClick={handleCloseNever}>
            확인
          </CustomizedButton>
        </Box>
      </Box>
    </Dialog>
  );
};

export default ServicePolicyDialog;

const useStyle = makeStyles(
  {
    modalContainer: {
      '& .MuiDialog-paperWidthSm': {
        width: 476,
        borderRadius: 12
      }
    }
  },
  { classNamePrefix: 'ServicePolicyDialog-' }
);
